import { createAsyncThunk } from '@reduxjs/toolkit';
import { getPrivateProjectBankFolderItems } from 'scenes/ProjectBank/services/private-project-bank/getPrivateProjectBankFolderItems.service';
import { selectIsBankKeptToImages } from 'scenes/ProjectBank/store/selectors/project-bank-access.selectors';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';

/**
 * Loads what is in one private folder (and the folder itself): a camera's
 * clips, its stills' day folders, a day's stills. The project's list leaves
 * these out, so the bank asks for each camera folder when it is opened
 * (useCameraBankFolders, and a link into one). Once per folder while the
 * bank is open: a folder loading or loaded is not asked again, a failed one
 * may be.
 *
 * @param {string} folderId
 * @returns {Array<Object>} the folder and its items, merged into the private items
 */
export const loadPrivateProjectBankFolderItems = createAsyncThunk(
  'project-bank/loadPrivateProjectBankFolderItems',
  async (folderId, { getState, rejectWithValue }) => {
    const projectId = selectSelectedProjectId(getState());

    const items = await getPrivateProjectBankFolderItems(projectId, folderId);

    if (selectSelectedProjectId(getState()) !== projectId) {
      return rejectWithValue({ stale: true, projectId });
    }
    return items;
  },
  {
    condition: (folderId, { getState }) => {
      if (!folderId || selectIsBankKeptToImages(getState())) return false;
      const status =
        getState().projectBank.privateFolderItemsStatus?.[folderId];
      return status !== 'loading' && status !== 'loaded';
    },
  }
);
